/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { Grid, Menu, Dropdown, Image } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import '../../app/styles/header.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckSquare, faBars } from '@fortawesome/fontawesome-free-solid';
// import {logo} from '../../assets/Logo.png'

const trigger = (
	<span>
		<Image
			avatar
			src="../../assets/userImage.png"
		/>
	</span>
);

// const userPermission = JSON.parse(localStorage.getItem('data'));
// const permissionObject = userPermission.details.userPermissions
// console.log("DATA FROM LOCALSTORAGE0->>>>>>>>>>>>>>>>", permissionObject);
// const [toggle, setToggle] = useState(false);

// const toggleMenu = () => {
//   setToggle(!toggle);
//   console.log("TOGGLE STATE->>>>>>>>>", toggle);
// }

const Navigation = ({ activeItem, handleItemClick, logout, toggleMenu, toggle, userPermission }) => {
	 const allPermission=JSON.parse(localStorage.getItem('allPermissions')) 
    return(
	<div className="mainHeaderContainer">
		 {console.log("nav allPermission",allPermission)}
		<div className="navBarFlex">
			<div className="leftHeaderItems">
				<div className="hamburgerIcon" onClick={toggleMenu}>
					<FontAwesomeIcon className="IconHamburger" icon={faBars} />
				</div>
				<div className="logoImage">
					<Image
						src="../../assets/DaalchiniDashboardLogo.JPG"
					/>
					{/* <img src='../../assets/Logo.png'  /> */}
				</div>
			</div>
			<div className="userAccount">
				<Menu.Menu position="right">
					<Dropdown
						trigger={trigger}
						item
						className="dropDownIcon"
						style={{ padding: '0 15px 0 15px' }}
					>
						<Dropdown.Menu className="menuRight">
							<Dropdown.Item
								disabled
								text={`Signed in as ${localStorage.data ? JSON.parse(localStorage.data).details.userDetails.full_name : 'N/A'}`}
							/>
							<Dropdown.Item
								disabled
								text={`${localStorage.data ? JSON.parse(localStorage.data).details.userDetails.mobile : 'N/A'}`}
							/>
							<Dropdown.Item
								name="user/profile"
								disabled
								onClick={handleItemClick}
							>
								<Link to="users/profile" style={{ color: 'black' }}> Your Profile </Link>
							</Dropdown.Item>
							<Dropdown.Item
								name="logout"
								onClick={logout}
							>
								<Link to="logout" style={{ color: 'black' }}> Logout </Link>
							</Dropdown.Item>
						</Dropdown.Menu>
					</Dropdown>
				</Menu.Menu>
				{/* <Image
          src="../../assetsLogo.png"
        /> */}
			</div>
		</div>
		{toggle ? (
			<Grid className="positionRelative">
				<Grid.Row>
					<Grid.Column>
						<Menu pointing fixed="top" size="large" className="flex-column">
							<Menu.Item name="home" active={activeItem === 'home'} onClick={handleItemClick} className="itemCustom">
								<Link to="home" style={{ color: 'black' }}> Home </Link>
							</Menu.Item>
							{allPermission && allPermission.view_bp_user == 1 ? (
								<Menu.Item name="myorganization" active={activeItem === 'myorganization'} onClick={handleItemClick} className="itemCustom">
									<Link to="myorganization" style={{ color: 'black' }}> My Organization </Link>
								</Menu.Item>
							) : ""

							
							}
							{allPermission && allPermission.vm_allowed == 1 ? (
								<Menu.Item name="sales&inventory" active={activeItem === 'sales&inventory'} onClick={handleItemClick} className="itemCustom">
									<Link to="sales&inventory" style={{ color: 'black' }}> Sales&Inventory </Link>
								</Menu.Item>
							) : ""

							}

							{userPermission && userPermission.details.userPermissions.product_allowed == 1 ? (
								<Menu.Menu name="products" active={activeItem === 'products'} onClick={handleItemClick}>
									<Dropdown className="dropDownContainer" item text="Products">
										<Dropdown.Menu className="menuItemDrop">
											<Dropdown.Item name="products" onClick={handleItemClick}>
												<Link to="products" style={{ color: 'black' }}> View All </Link>
											</Dropdown.Item>
											{/* <Dropdown item text="Products">
                        <Dropdown.Menu  >
                          <Dropdown.Item name="products/new" onClick={handleItemClick}>
                            <Link to="products/new" style={{ color: 'black' }}> Create </Link>
                          </Dropdown.Item>
                          <Dropdown.Item name="products/update" onClick={handleItemClick}>
                            <Link to="products/update" style={{ color: 'black' }}> Update </Link>
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown> */}
											{/* <Dropdown item text="Variants">
                        <Dropdown.Menu>
                          <Dropdown.Item name="products/variants" onClick={handleItemClick}>
                            <Link to="products/variants" style={{ color: 'black' }}> Create </Link>
                          </Dropdown.Item>
                          <Dropdown.Item name="products/variants/update" onClick={handleItemClick}>
                            <Link to="products/variants/update" style={{ color: 'black' }}> Update </Link>
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown> */}
											{/* <Dropdown item text="MFG">
                        <Dropdown.Menu>
                          <Dropdown.Item name="products/mvs" onClick={handleItemClick}>
                            <Link to="products/mvs" style={{ color: 'black' }}> Create </Link>
                          </Dropdown.Item>
                          <Dropdown.Item name="products/mvs/update" onClick={handleItemClick}>
                            <Link to="products/mvs/update" style={{ color: 'black' }}> Update </Link>
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown> */}
										</Dropdown.Menu>
									</Dropdown>
								</Menu.Menu>
							) : ""

							}

							{userPermission && userPermission.details.userPermissions.vm_allowed == 1 ? (
								<Menu.Menu
									name="vendingmachines"
									active={activeItem === 'vendingmachines'}
									onClick={handleItemClick}
								>
									<Dropdown className="dropDownContainer" item text="Vending Machines">
										<Dropdown.Menu className="menuItemDrop">
											<Dropdown item text="Vending Machines">
												<Dropdown.Menu>
													<Dropdown.Item name="vendingmachines" onClick={handleItemClick}>
														<Link to="vendingmachines" style={{ color: 'black' }}> View All </Link>
													</Dropdown.Item>
													<Dropdown.Item name="vendingmachines/new" onClick={handleItemClick}>
														<Link to="vendingmachines/new" style={{ color: 'black' }}> Create VM </Link>
													</Dropdown.Item>
													<Dropdown item text="Payment">
														<Dropdown.Menu>
															<Dropdown.Item name="vendingmachines/pg/new" onClick={handleItemClick}>
																<Link to="vendingmachines/pg/new" style={{ color: 'black' }}> Create Mapping </Link>
															</Dropdown.Item>
															<Dropdown.Item name="vendingmachines/pg/options" onClick={handleItemClick}>
																<Link to="vendingmachines/pg/options" style={{ color: 'black' }}> List Mappings </Link>
															</Dropdown.Item>
														</Dropdown.Menu>
													</Dropdown>
													<Dropdown item text="Remote Config">
														<Dropdown.Menu>
															<Dropdown.Item name="vendingmachines/rc/screensaver" onClick={handleItemClick}>
																<Link to="vendingmachines/rc/screensaver" style={{ color: 'black' }}> Screensaver </Link>
															</Dropdown.Item>
														</Dropdown.Menu>
													</Dropdown>
												</Dropdown.Menu>
											</Dropdown>{' '}
											<Dropdown item text="Cohorts">
												<Dropdown.Menu>
													<Dropdown.Item name="vendingmachines/cohorts/list" onClick={handleItemClick}>
														<Link to="vendingmachines/cohorts/list" style={{ color: 'black' }}> View All </Link>
													</Dropdown.Item>
													<Dropdown.Item name="vendingmachines/cohorts/new" onClick={handleItemClick}>
														<Link to="vendingmachines/cohorts/new" style={{ color: 'black' }}> Create </Link>
													</Dropdown.Item>
												</Dropdown.Menu>
											</Dropdown>{' '}
										</Dropdown.Menu>
									</Dropdown>
								</Menu.Menu>
							) : ""

							}

							{userPermission && userPermission.details.userPermissions.orders_allowed == 1 ? (
								<Menu.Menu name="orders" active={activeItem === 'orders'}>
									<Dropdown className="dropDownContainer" item text="Orders">
										<Dropdown.Menu className="menuItemDrop">
											<Dropdown.Item name="orders" onClick={handleItemClick}>
												<Link to="orders" style={{ color: 'black' }}> View All </Link>
											</Dropdown.Item>
											<Dropdown.Item name="orders_search" onClick={handleItemClick}>
												<Link to="orders_search" style={{ color: 'black' }}> Search </Link>
											</Dropdown.Item>
										</Dropdown.Menu>
									</Dropdown>
								</Menu.Menu>
							) : ""

							}



							{/* <Menu.Item name="downloads" active={activeItem === 'downloads'} onClick={handleItemClick}>
                <Link to="downloads" style={{ color: 'black' }}> Downloads </Link>
              </Menu.Item> */}

							{userPermission && userPermission.details.userPermissions.user_allowed == 1 ? (
								<Menu.Menu name="users" active={activeItem === 'users'} >
									<Dropdown className="dropDownContainer" item text="Users" >
										<Dropdown.Menu className="menuItemDrop">
											<Dropdown.Item name="users/list" onClick={handleItemClick}>
												<Link to="users/list" style={{ color: 'black' }}> View All </Link>
											</Dropdown.Item>
											<Dropdown.Item name="users/new" onClick={handleItemClick}>
												<Link to="users/new" style={{ color: 'black' }}> Create </Link>
											</Dropdown.Item>
											<Dropdown.Item name="users/search" onClick={handleItemClick}>
												<Link to="users/search" style={{ color: 'black' }}> Search </Link>
											</Dropdown.Item>
											{/* <Dropdown item text="Assign" >
                      <Dropdown.Menu>
                        <Dropdown.Item name="users/vms" onClick={handleItemClick}>
                          <Link to="users/vms" style={{ color: 'black' }}> VM </Link>
                        </Dropdown.Item>
                         <Dropdown.Item name="users/mfs" onClick={handleItemClick}>
                          <Link to="users/mfs" style={{ color: 'black' }}>  MFG </Link>
                        </Dropdown.Item>
                      </Dropdown.Menu>
                </Dropdown> */}
										</Dropdown.Menu>
									</Dropdown>
								</Menu.Menu>
							) : ""

							}



							{/* <Menu.Menu position="right">
              <Dropdown
                trigger={trigger}
                item
                style={{ padding: '0 15px 0 15px' }}
              >
                <Dropdown.Menu>
                  <Dropdown.Item
                    disabled
                    text={`Signed in as ${localStorage.data ? JSON.parse(localStorage.data).details.userDetails.full_name : 'N/A'}`}
                  />
                  <Dropdown.Item
                    disabled
                    text={`${localStorage.data ? JSON.parse(localStorage.data).details.userDetails.mobile : 'N/A'}`}
                  />
                  <Dropdown.Item
                    name="user/profile"
                    disabled
                    onClick={handleItemClick}
                  >
                    <Link to="users/profile" style={{ color: 'black' }}> Your Profile </Link>
                  </Dropdown.Item>
                  <Dropdown.Item
                    name="logout"
                    onClick={logout}
                  >
                    <Link to="logout" style={{ color: 'black' }}> Logout </Link>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Menu.Menu> */}
						</Menu>
					</Grid.Column>


				</Grid.Row>
			</Grid>
		) : ""

		}
	</div>
	)
	}


export default Navigation;


// WEBPACK FOOTER //
// ./src/Modules/Navigation/component.jsx